// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .sidebar {
    width: 250px;
    height: 100vh;
    background-color: var(--primary-grey);
    position: fixed;
    left: 0;
    top: 0;
    color: var(--primary-yellow);
    z-index: 1000;
    transition: width 0.3s ease;
  }
  .menu-item-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 8px 15px;
  }
  
  .menu-item-left {
    display: flex;
    align-items: center;
    gap: var(--spacing-md);
  }
  .sidebar.collapsed {
    width: 60px;
  }
  .sidebar-header {
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
   
    overflow: hidden;

  padding:  var(--spacing-sm);
  }
  .sidebar-header .logo-large {
    height: 50px;
    width: auto;
    object-fit: contain;
  }

  .sidebar-header .logo {
    height: 30px;
    width: auto;
    object-fit: contain;
  }
  
  
  .sidebar.collapsed .sidebar-header .logo {
    height: 30px; 
  }
  

  .sidebar.collapsed .sidebar-header h2 {
    display: none;
  }
  
  .sidebar-menu {
    list-style: none;
    padding: var(--spacing-md) 0;
    margin-top: 8px;
  }
  

  .sidebar-menu li a {
    display: block;
    text-decoration: none;
    color: #fff;
    width: 100%;
  }

  .sidebar-menu li a:hover,
  .sidebar-menu li a.active {
    background-color: var(--secondary-grey);
  }
  .sidebar-menu li a span {
    transition: opacity 0.3s ease;
    font-size: 14px;
  }
  
  .sidebar.collapsed .sidebar-menu li a span {
    display: none;
  }
  .sidebar.collapsed .sidebar-menu li a {
    
    padding: 0.2rem;
    justify-content: center;
  }
  
  .sidebar-menu li a i {
    margin-right: var(--spacing-sm);
    width: 20px;
    text-align: center;
  }
  
  .sidebar.collapsed .sidebar-menu li a i {
    margin-right: 0;
  }

  .submenu-arrow {
    font-size: 12px;
    margin-left: auto;
    width: 20px;
    text-align: center;
  }
  

  .submenu {
    list-style: none;
    padding-left: 0;
    background-color: rgba(255, 255, 255, 0.05);
  }
  
  .submenu li a {
    padding: 3px 14px 2px 35px;
  }
  
  .submenu-dot {
    font-size: 5px;
    margin-right: 10px;
  }
  
  .sidebar.collapsed .menu-item-content {
    justify-content: center;
    padding: 8px;
  }
  
  .sidebar.collapsed .submenu {
    display: none;
  }


  @media (max-width: 768px) {
    .sidebar {
     
      transition: transform 0.3s ease;
      width: 215px;
      left: 0%;
    }
  
    .sidebar.open {
      transform: translateX(0);
    }

    .sidebar.collapsed {
      width: 215px !important;
    }

  } */


  
  .sidebar {
    width: 250px;
    height: 100vh;
    background-color: var(--primary-grey);
    position: fixed;
    left: 0;
    top: 0;
    color: var(--primary-yellow);
    z-index: 1000;
    transition: all 0.3s ease;
  }
  .menu-item-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 8px 15px;
  }
   
  .menu-item-left {
    display: flex;
    align-items: center;
    gap: var(--spacing-md);
  }
  .sidebar.collapsed {
    width: 60px;
  }
  .sidebar.collapsed.hovered {
    width: 250px;
  }
  .sidebar.collapsed.hovered .sidebar-menu li a span {
    display: inline-block !important;
    opacity: 1 !important;
    transition: opacity 0.3s ease;
  }
  .sidebar.collapsed.hovered .menu-item-content {
    justify-content: space-between;
    padding: 8px 15px;
  }
  .sidebar.collapsed.hovered .submenu {
    display: block;
  }
  .sidebar.collapsed.hovered .sidebar-header .logo {
    display: none;
  }
  .sidebar.collapsed.hovered .sidebar-header .logo-large {
    display: block;
  }
  .sidebar.collapsed .sidebar-header .logo-large {
    display: none;
  }
  .sidebar-header {
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
   
    overflow: hidden;
   
    padding: var(--spacing-sm);
  }
  .sidebar-header .logo-large {
    height: 50px;
    width: auto;
    object-fit: contain;
  }
   
  .sidebar-header .logo {
    height: 30px;
    width: auto;
    object-fit: contain;
  }
   
  .sidebar.collapsed .sidebar-header .logo {
    height: 30px;
  }
   
  .sidebar.collapsed .sidebar-header h2 {
    display: none;
  }
   
  .sidebar-menu {
    list-style: none;
    padding: var(--spacing-md) 0;
    margin-top: 8px;
  }
   
  .sidebar-menu li a {
    display: block;
    text-decoration: none;
    color: #fff;
    width: 100%;
  }
   
  .sidebar-menu li a:hover,
  .sidebar-menu li a.active {
    background-color: var(--secondary-grey);
  }
  .sidebar-menu li a span {
    transition: opacity 0.3s ease;
    font-size: 14px;
    /* white-space: nowrap; */
  }
   
  .sidebar.collapsed .sidebar-menu li a span {
    display: none;
    opacity: 0;
    transition: opacity 0.3s ease;
  }
  .sidebar.collapsed .sidebar-menu li a {
    padding: 0.2rem;
    justify-content: center;
  }
   
  .sidebar-menu li a i {
    margin-right: var(--spacing-sm);
    width: 20px;
    text-align: center;
  }
   
  .sidebar.collapsed .sidebar-menu li a i {
    margin-right: 0;
  }
   
  .submenu-arrow {
    font-size: 12px;
    margin-left: auto;
    width: 20px;
    text-align: center;
  }
   
  .submenu {
    list-style: none;
    padding-left: 0;
    background-color: rgba(255, 255, 255, 0.05);
  }
   
  .submenu li a {
    padding: 3px 14px 2px 35px;
  }
   
  .submenu-dot {
    font-size: 5px;
    margin-right: 10px;
  }
   
  .sidebar.collapsed .menu-item-content {
    justify-content: center;
    padding: 8px;
    transition: all 0.3s ease;
  }
   
  .sidebar.collapsed .submenu {
    display: none;
  }
   
  .sidebar.collapsed.hovered .sidebar-menu li a span {
    display: inline-block !important;
    opacity: 1 !important;
    transition: opacity 0.3s ease;
  }
   
  .sidebar.collapsed.hovered .menu-item-content {
    justify-content: space-between;
    padding: 8px 15px;
    transition: all 0.3s ease;
  }
  .sidebar.collapsed.hovered .submenu li a {
    padding: 3px 14px 2px 35px !important;
  }
   
  @media (max-width: 768px) {
    .sidebar {
      transition: transform 0.3s ease;
      width: 215px;
      left: 0%;
    }
   
    .sidebar.open {
      transform: translateX(0);
    }
   
    .sidebar.collapsed {
      width: 60px !important;
      display: none !important;
    }
   
    .sidebar.collapsed.hovered {
      width: 215px !important;
    }
  }`, "",{"version":3,"sources":["webpack://./src/styles/components/sidebar.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;KAsJK;;;;EAIH;IACE,YAAY;IACZ,aAAa;IACb,qCAAqC;IACrC,eAAe;IACf,OAAO;IACP,MAAM;IACN,4BAA4B;IAC5B,aAAa;IACb,yBAAyB;EAC3B;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,gCAAgC;IAChC,qBAAqB;IACrB,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,iBAAiB;EACnB;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;IAEvB,gBAAgB;;IAEhB,0BAA0B;EAC5B;EACA;IACE,YAAY;IACZ,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,4BAA4B;IAC5B,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,qBAAqB;IACrB,WAAW;IACX,WAAW;EACb;;EAEA;;IAEE,uCAAuC;EACzC;EACA;IACE,6BAA6B;IAC7B,eAAe;IACf,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,UAAU;IACV,6BAA6B;EAC/B;EACA;IACE,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,+BAA+B;IAC/B,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,2CAA2C;EAC7C;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,YAAY;IACZ,yBAAyB;EAC3B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gCAAgC;IAChC,qBAAqB;IACrB,6BAA6B;EAC/B;;EAEA;IACE,8BAA8B;IAC9B,iBAAiB;IACjB,yBAAyB;EAC3B;EACA;IACE,qCAAqC;EACvC;;EAEA;IACE;MACE,+BAA+B;MAC/B,YAAY;MACZ,QAAQ;IACV;;IAEA;MACE,wBAAwB;IAC1B;;IAEA;MACE,sBAAsB;MACtB,wBAAwB;IAC1B;;IAEA;MACE,uBAAuB;IACzB;EACF","sourcesContent":["/* .sidebar {\r\n    width: 250px;\r\n    height: 100vh;\r\n    background-color: var(--primary-grey);\r\n    position: fixed;\r\n    left: 0;\r\n    top: 0;\r\n    color: var(--primary-yellow);\r\n    z-index: 1000;\r\n    transition: width 0.3s ease;\r\n  }\r\n  .menu-item-content {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    width: 100%;\r\n    padding: 8px 15px;\r\n  }\r\n  \r\n  .menu-item-left {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: var(--spacing-md);\r\n  }\r\n  .sidebar.collapsed {\r\n    width: 60px;\r\n  }\r\n  .sidebar-header {\r\n    height: 60px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n   \r\n    overflow: hidden;\r\n\r\n  padding:  var(--spacing-sm);\r\n  }\r\n  .sidebar-header .logo-large {\r\n    height: 50px;\r\n    width: auto;\r\n    object-fit: contain;\r\n  }\r\n\r\n  .sidebar-header .logo {\r\n    height: 30px;\r\n    width: auto;\r\n    object-fit: contain;\r\n  }\r\n  \r\n  \r\n  .sidebar.collapsed .sidebar-header .logo {\r\n    height: 30px; \r\n  }\r\n  \r\n\r\n  .sidebar.collapsed .sidebar-header h2 {\r\n    display: none;\r\n  }\r\n  \r\n  .sidebar-menu {\r\n    list-style: none;\r\n    padding: var(--spacing-md) 0;\r\n    margin-top: 8px;\r\n  }\r\n  \r\n\r\n  .sidebar-menu li a {\r\n    display: block;\r\n    text-decoration: none;\r\n    color: #fff;\r\n    width: 100%;\r\n  }\r\n\r\n  .sidebar-menu li a:hover,\r\n  .sidebar-menu li a.active {\r\n    background-color: var(--secondary-grey);\r\n  }\r\n  .sidebar-menu li a span {\r\n    transition: opacity 0.3s ease;\r\n    font-size: 14px;\r\n  }\r\n  \r\n  .sidebar.collapsed .sidebar-menu li a span {\r\n    display: none;\r\n  }\r\n  .sidebar.collapsed .sidebar-menu li a {\r\n    \r\n    padding: 0.2rem;\r\n    justify-content: center;\r\n  }\r\n  \r\n  .sidebar-menu li a i {\r\n    margin-right: var(--spacing-sm);\r\n    width: 20px;\r\n    text-align: center;\r\n  }\r\n  \r\n  .sidebar.collapsed .sidebar-menu li a i {\r\n    margin-right: 0;\r\n  }\r\n\r\n  .submenu-arrow {\r\n    font-size: 12px;\r\n    margin-left: auto;\r\n    width: 20px;\r\n    text-align: center;\r\n  }\r\n  \r\n\r\n  .submenu {\r\n    list-style: none;\r\n    padding-left: 0;\r\n    background-color: rgba(255, 255, 255, 0.05);\r\n  }\r\n  \r\n  .submenu li a {\r\n    padding: 3px 14px 2px 35px;\r\n  }\r\n  \r\n  .submenu-dot {\r\n    font-size: 5px;\r\n    margin-right: 10px;\r\n  }\r\n  \r\n  .sidebar.collapsed .menu-item-content {\r\n    justify-content: center;\r\n    padding: 8px;\r\n  }\r\n  \r\n  .sidebar.collapsed .submenu {\r\n    display: none;\r\n  }\r\n\r\n\r\n  @media (max-width: 768px) {\r\n    .sidebar {\r\n     \r\n      transition: transform 0.3s ease;\r\n      width: 215px;\r\n      left: 0%;\r\n    }\r\n  \r\n    .sidebar.open {\r\n      transform: translateX(0);\r\n    }\r\n\r\n    .sidebar.collapsed {\r\n      width: 215px !important;\r\n    }\r\n\r\n  } */\r\n\r\n\r\n  \r\n  .sidebar {\r\n    width: 250px;\r\n    height: 100vh;\r\n    background-color: var(--primary-grey);\r\n    position: fixed;\r\n    left: 0;\r\n    top: 0;\r\n    color: var(--primary-yellow);\r\n    z-index: 1000;\r\n    transition: all 0.3s ease;\r\n  }\r\n  .menu-item-content {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    width: 100%;\r\n    padding: 8px 15px;\r\n  }\r\n   \r\n  .menu-item-left {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: var(--spacing-md);\r\n  }\r\n  .sidebar.collapsed {\r\n    width: 60px;\r\n  }\r\n  .sidebar.collapsed.hovered {\r\n    width: 250px;\r\n  }\r\n  .sidebar.collapsed.hovered .sidebar-menu li a span {\r\n    display: inline-block !important;\r\n    opacity: 1 !important;\r\n    transition: opacity 0.3s ease;\r\n  }\r\n  .sidebar.collapsed.hovered .menu-item-content {\r\n    justify-content: space-between;\r\n    padding: 8px 15px;\r\n  }\r\n  .sidebar.collapsed.hovered .submenu {\r\n    display: block;\r\n  }\r\n  .sidebar.collapsed.hovered .sidebar-header .logo {\r\n    display: none;\r\n  }\r\n  .sidebar.collapsed.hovered .sidebar-header .logo-large {\r\n    display: block;\r\n  }\r\n  .sidebar.collapsed .sidebar-header .logo-large {\r\n    display: none;\r\n  }\r\n  .sidebar-header {\r\n    height: 60px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n   \r\n    overflow: hidden;\r\n   \r\n    padding: var(--spacing-sm);\r\n  }\r\n  .sidebar-header .logo-large {\r\n    height: 50px;\r\n    width: auto;\r\n    object-fit: contain;\r\n  }\r\n   \r\n  .sidebar-header .logo {\r\n    height: 30px;\r\n    width: auto;\r\n    object-fit: contain;\r\n  }\r\n   \r\n  .sidebar.collapsed .sidebar-header .logo {\r\n    height: 30px;\r\n  }\r\n   \r\n  .sidebar.collapsed .sidebar-header h2 {\r\n    display: none;\r\n  }\r\n   \r\n  .sidebar-menu {\r\n    list-style: none;\r\n    padding: var(--spacing-md) 0;\r\n    margin-top: 8px;\r\n  }\r\n   \r\n  .sidebar-menu li a {\r\n    display: block;\r\n    text-decoration: none;\r\n    color: #fff;\r\n    width: 100%;\r\n  }\r\n   \r\n  .sidebar-menu li a:hover,\r\n  .sidebar-menu li a.active {\r\n    background-color: var(--secondary-grey);\r\n  }\r\n  .sidebar-menu li a span {\r\n    transition: opacity 0.3s ease;\r\n    font-size: 14px;\r\n    /* white-space: nowrap; */\r\n  }\r\n   \r\n  .sidebar.collapsed .sidebar-menu li a span {\r\n    display: none;\r\n    opacity: 0;\r\n    transition: opacity 0.3s ease;\r\n  }\r\n  .sidebar.collapsed .sidebar-menu li a {\r\n    padding: 0.2rem;\r\n    justify-content: center;\r\n  }\r\n   \r\n  .sidebar-menu li a i {\r\n    margin-right: var(--spacing-sm);\r\n    width: 20px;\r\n    text-align: center;\r\n  }\r\n   \r\n  .sidebar.collapsed .sidebar-menu li a i {\r\n    margin-right: 0;\r\n  }\r\n   \r\n  .submenu-arrow {\r\n    font-size: 12px;\r\n    margin-left: auto;\r\n    width: 20px;\r\n    text-align: center;\r\n  }\r\n   \r\n  .submenu {\r\n    list-style: none;\r\n    padding-left: 0;\r\n    background-color: rgba(255, 255, 255, 0.05);\r\n  }\r\n   \r\n  .submenu li a {\r\n    padding: 3px 14px 2px 35px;\r\n  }\r\n   \r\n  .submenu-dot {\r\n    font-size: 5px;\r\n    margin-right: 10px;\r\n  }\r\n   \r\n  .sidebar.collapsed .menu-item-content {\r\n    justify-content: center;\r\n    padding: 8px;\r\n    transition: all 0.3s ease;\r\n  }\r\n   \r\n  .sidebar.collapsed .submenu {\r\n    display: none;\r\n  }\r\n   \r\n  .sidebar.collapsed.hovered .sidebar-menu li a span {\r\n    display: inline-block !important;\r\n    opacity: 1 !important;\r\n    transition: opacity 0.3s ease;\r\n  }\r\n   \r\n  .sidebar.collapsed.hovered .menu-item-content {\r\n    justify-content: space-between;\r\n    padding: 8px 15px;\r\n    transition: all 0.3s ease;\r\n  }\r\n  .sidebar.collapsed.hovered .submenu li a {\r\n    padding: 3px 14px 2px 35px !important;\r\n  }\r\n   \r\n  @media (max-width: 768px) {\r\n    .sidebar {\r\n      transition: transform 0.3s ease;\r\n      width: 215px;\r\n      left: 0%;\r\n    }\r\n   \r\n    .sidebar.open {\r\n      transform: translateX(0);\r\n    }\r\n   \r\n    .sidebar.collapsed {\r\n      width: 60px !important;\r\n      display: none !important;\r\n    }\r\n   \r\n    .sidebar.collapsed.hovered {\r\n      width: 215px !important;\r\n    }\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
